import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const scheduleAnnouncement = async (id: number): Promise<void> => {
	await cmsClient.patch(`/announcements/${id}/`, { status: "scheduled" });
};

const useScheduleAnnouncement = () => {
	const queryClient = useQueryClient();

	const onSuccess = (_data: void, id: number) => {
		toast.success(
			<CustomToast type="Success" message="Announcement scheduled" />,
			{ hideProgressBar: true }
		);
		queryClient.invalidateQueries(["announcements"]);
		queryClient.invalidateQueries(["announcement", id]);
	};

	const onError = (error: unknown) => {
		const axiosError = error as AxiosError<{ detail?: string }>;
		const backendMessage = axiosError?.response?.data?.detail;
		const message =
			axiosError?.response?.status === 409 && backendMessage
				? backendMessage
				: "Something went wrong, try again";
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(scheduleAnnouncement, { onError, onSuccess });
	return mutation;
};

export default useScheduleAnnouncement;
